
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import ResourceTabs from "@/components/resources/ResourceTabs";
import ResourceSidebarStats from "@/components/resources/ResourceSidebarStats";

const ResourcesPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navbar />
      
      <div className="flex-1 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="container mx-auto max-w-7xl">
          <header className="mb-8 text-center">
            <h1 className="text-4xl font-bold mb-4">AI Resources Hub</h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Discover curated AI tools, prompt templates, tutorials, and the latest insights 
              to enhance your AI workflow and prompt engineering skills
            </p>
          </header>
          
          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            {/* Main Content */}
            <div className="lg:col-span-3">
              <ResourceTabs />
            </div>
            
            {/* Sidebar */}
            <div className="lg:col-span-1 space-y-6">
              <ResourceSidebarStats />
              
              {/* Quick Tips Card */}
              <div className="bg-secondary/30 rounded-xl p-6">
                <h3 className="text-lg font-semibold mb-3">💡 Quick Tips</h3>
                <ul className="space-y-2 text-sm text-muted-foreground">
                  <li>• Use filters to find specific resource types</li>
                  <li>• Bookmark resources to access them later</li>
                  <li>• Check the "Latest Posts" tab for fresh content</li>
                  <li>• Rate resources to help the community</li>
                </ul>
              </div>
              
              {/* Submit Resource Card */}
              <div className="bg-primary/10 border border-primary/20 rounded-xl p-6">
                <h3 className="text-lg font-semibold mb-3">📤 Submit a Resource</h3>
                <p className="text-sm text-muted-foreground mb-4">
                  Know of a great AI tool or resource? Share it with the community!
                </p>
                <button className="w-full bg-primary text-primary-foreground px-4 py-2 rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors">
                  Submit Resource
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default ResourcesPage;
